import { render } from "./makeMessagesAsRead.vue?vue&type=template&id=1ad8a9b8"
import script from "./makeMessagesAsRead.vue?vue&type=script&lang=js"
export * from "./makeMessagesAsRead.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__